export default __webpack_public_path__ + "static/media/sport4.78e884d0.wav";